import { getField, updateField } from 'vuex-map-fields';

export default {
  namespaced: true,
  state: {
    dialogOpened: false,
    for_migration: 0,
  },
  mutations: {
    updateField,
    openDialog: (state) => {
      state.dialogOpened = true;
    },
    closeDialog: (state) => {
      state.dialogOpened = false;
    },
  },
  actions: {
    openDialog: ({ commit }) => {
      commit('openDialog');
    },
    closeDialog: ({ commit }) => {
      commit('closeDialog');
    },
  },
  getters: {
    getField,
  },
};
